import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m14 12.5 1 5.5-3-1-3 1 1-5.5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileBadge2";
const FileBadge2 = memo(themed(Icon));
export {
  FileBadge2
};
//# sourceMappingURL=file-badge-2.js.map
